import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { PositionProvider } from "../../../context/PositionContext";

export const Party = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddParty = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditParty = () => {
  return (
    
      
        <Edit />
      
    
  );
};
